import _asyncToGenerator from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/regenerator/index.js";
import { Web3Provider } from '@ethersproject/providers';
import detectEthereumProvider from '@metamask/detect-provider';
export function getInjectedProvider(_x) {
  return _getInjectedProvider.apply(this, arguments);
}

function _getInjectedProvider() {
  _getInjectedProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pollingInterval) {
    var injectedProvider, provider;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return detectEthereumProvider();

          case 2:
            injectedProvider = _context.sent;

            if (injectedProvider) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", undefined);

          case 5:
            provider = new Web3Provider(injectedProvider, 'any');
            provider.pollingInterval = pollingInterval;
            return _context.abrupt("return", provider);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getInjectedProvider.apply(this, arguments);
}